import { ridSegment } from '@krp/client-runtime'

/** Служебные ручки Resource.Aqsi по одному кабинету (`diagnostics.read`); очереди заданий нет с RP-LSC1. */
const base = (resourceId: string) => `/api/aqsi/v1/resources/${ridSegment(resourceId)}`

export const AQSI_CONNECTION_URLS = {
  profile: (resourceId: string) => `${base(resourceId)}/capabilities`,
} as const
